import {
  Flex, Text, VStack,
} from '@chakra-ui/react';
import { get } from '@submize/lodash';
import { useDispatch } from 'react-redux';
import { setFieldStyles } from '../../formSlice';
import InputSetting from '../../../InputSetting';

export const borderStyleOptions = [
  { key: 'none', value: 'None' },
  { key: 'solid', value: 'Solid' },
  { key: 'dotted', value: 'Dotted' },
  { key: 'dashed', value: 'Dashed' },
  { key: 'inset', value: 'Inset' },
];

const fieldStyles = ({ design }) => {
  const dispatch = useDispatch();

  return (
    <VStack color="gray.600" fontSize="sm" gap="3">
      <Text fontWeight="bold">Field</Text>
      <Flex justify="space-between" w="100%">
        <InputSetting
          label="Padding vertical"
          value={get(design, 'fields.paddingY', '')}
          onChange={(v) => dispatch(setFieldStyles({ paddingY: v }))}
          regex={/(^[0-9]+ ?px)?$/}
          errorMessage="Width must be in px"
        />
      </Flex>
      <Flex justify="space-between" w="100%">
        <InputSetting
          label="Padding horizontal"
          value={get(design, 'fields.paddingX', '')}
          onChange={(v) => dispatch(setFieldStyles({ paddingX: v }))}
          regex={/(^[0-9]+ ?px)?$/}
          errorMessage="Width must be in px"
        />
      </Flex>
    </VStack>
  );
};

export default fieldStyles;
